import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateFrom } from '@app/model/enums/navigate-from.enum';
import { LearningPathModel } from '@app/model/learning-path.model';
import { LearningPathService } from '@app/services/api/learning-path.service';
import { SettingsService } from '@app/services/settings.service';
import { BundleType, SwiperComponent } from 'library-explorer';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-learning-path-block',
    templateUrl: './learning-path-block.component.html',
    styleUrls: ['./learning-path-block.component.scss'],
    standalone: false
})
export class LearningPathBlockComponent implements OnInit, OnDestroy {

  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent

  @Input() block: any;
  
  public learningPathList: LearningPathModel[] = [];
  public activeLearningPaths = 0;
  public completedLearningPaths = 0;
  public swiperContainer: any;
  public cardSettings: any;

  public BundleType = BundleType;
  public NavigateFrom = NavigateFrom;

  public swiperOptions = {
    breakpoints: {
      0: {
        slidesPerView: 1,
        reducedWidth: true,
        showOverflow: true
      },
      480: {
        slidesPerView: 1,
        reducedWidth: false,
        showOverflow: false
      }
    }
  };

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly learningPathService: LearningPathService,
    private readonly router: Router,
    private readonly settingsService: SettingsService
  ) { }

  ngOnInit(): void {
    this.learningPathList = this.block.contents.map(this.learningPathService.processLearningPath);
    this.activeLearningPaths = this.learningPathList.reduce((prev, item) => prev += item.progress !== 100 ? 1 : 0, 0)
    this.completedLearningPaths = this.learningPathList.reduce((prev, item) => prev += item.progress === 100 ? 1 : 0, 0)
    this.settingsService.getSettings().subscribe(settings => {
      this.cardSettings = settings.layout.cards?.learning_path;
    })
  }

  public navigateToLearningPath(learningPath: LearningPathModel, event: MouseEvent): void {
    this.router.navigate(['/learning-path', learningPath.uuid]);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
